import React, { useState } from 'react';
import './App.css';
import Hero from './components/Hero';
import Project from './components/Project';
import Team from './components/Team';
import Contact from './components/Contact';
import Header from './components/Header';

function App() {
  const [theme, setTheme] = useState('green');

  const toggleTheme = () => {
    setTheme(prev => prev === 'green' ? 'blue' : 'green');
  };

  return (
    <div className={`App ${theme}-theme`}>
      <Header toggleTheme={toggleTheme} currentTheme={theme} />
      <Hero />
      <Project />
      <Team />
      <Contact />
    </div>
  );
}

export default App;

